import CtaBand from "../components/CtaBand";

const PRINCIPLES = [
  { k: "Fast", body: "We ship working software early and often. You see real progress every week, not a status report — and you can change course while it's still cheap to." },
  { k: "Precise", body: "Speed without control is just chaos. Tight scope, tested code, and honest estimates keep the pace sustainable and the result dependable." },
  { k: "Plain-spoken", body: "We explain software in language you recognise, flag trade-offs early, and never hide behind jargon. Clear beats clever, every time." },
];

export default function About() {
  return (
    <>
      <section className="pagehead">
        <div className="container">
          <p className="eyebrow">About</p>
          <h1 className="display-lg">Momentum, made dependable.</h1>
          <p className="lead">
            Agile Software Ltd is a UK software studio. We help businesses build and
            connect the software they run on &mdash; quickly, and without the risk that
            usually comes with moving quickly.
          </p>
        </div>
      </section>

      <section className="section" style={{ paddingTop: "clamp(16px, 3vw, 32px)" }}>
        <div className="container grid grid--2" style={{ alignItems: "start", gap: "clamp(28px,5vw,64px)" }}>
          <div style={{ display: "flex", flexDirection: "column", gap: 18 }}>
            <h2 className="display-md">Why we exist</h2>
            <p className="lead">
              Plenty of software projects are slow, opaque, and end with something nobody
              can maintain. We started Agile Software to work the opposite way: short
              cycles, deployable slices, and a clean handover as the default.
            </p>
            <p className="lead">
              The name is the promise. &ldquo;Agile&rdquo; is how we deliver &mdash;
              iteratively, transparently, with you in the loop. &ldquo;Limited&rdquo; is
              the accountability &mdash; a registered company you can put on a contract,
              with the paperwork and continuity that implies.
            </p>
          </div>
          <div style={{ display: "flex", flexDirection: "column", gap: 18 }}>
            <h2 className="display-md">Who we work with</h2>
            <p className="lead">
              Small and mid-sized businesses, and in-house teams that need extra delivery
              capacity or a specialist for a stretch of work. If you have a clear problem
              and want it solved properly, we're a good fit.
            </p>
            <p className="lead">
              Every engagement is scoped and billed transparently. We'll tell you when
              something is out of scope rather than quietly building it &mdash; and when
              buying beats building, we'll say so.
            </p>
          </div>
        </div>
      </section>

      <section className="section section--charcoal">
        <div className="container">
          <p className="eyebrow">What we value</p>
          <h2 className="display-lg" style={{ margin: "16px 0 44px", maxWidth: "16ch" }}>
            Three principles, on every job.
          </h2>
          <div className="steps">
            {PRINCIPLES.map((p) => (
              <div className="step" key={p.k}>
                <span style={{ fontFamily: "var(--core-font-display)", fontWeight: 800, fontStyle: "italic", fontSize: 22, color: "var(--core-accent)" }}>
                  {p.k}
                </span>
                <div>
                  <p style={{ color: "#d4d4d8", fontSize: 16.5, maxWidth: "60ch" }}>{p.body}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <CtaBand />
    </>
  );
}
